/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob17IndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob17IndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  fetchIsLoading: false
});

export const whseJob17IndexFetchWhseJob17IndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob17IndexFetchWhseJob17IndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob17IndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ].slice(0, 5)
  };
};

export const whseJob17IndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob17IndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob17IndexTypes.WHSE_JOB17_INDEX_RESET_TIMESTAMP]: whseJob17IndexResetTimestamp,
  [WhseJob17IndexTypes.WHSE_JOB17_INDEX_FETCH_WHSE_JOB17_INDEX_LOADING]: whseJob17IndexFetchWhseJob17IndexLoading,
  [WhseJob17IndexTypes.WHSE_JOB17_INDEX_FETCH_WHSE_JOB17_INDEX_SUCCESS]: whseJob17IndexFetchWhseJob17IndexSuccess,
  [WhseJob17IndexTypes.WHSE_JOB17_INDEX_ADD_SELECTED_DOCUMENTS]: whseJob17IndexAddSelectedDocuments,
  [WhseJob17IndexTypes.WHSE_JOB17_INDEX_REMOVE_SELECTED_DOCUMENTS]: whseJob17IndexRemoveSelectedDocuments,
  [WhseJob17IndexTypes.WHSE_JOB17_INDEX_SET_WORKSPACE_VISIBLE]: whseJob17IndexSetWorkspaceVisible
});
